module.exports = __webpack_public_path__ + "static/img/beans.bc3f45d2.png";